// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v4.25.3
// source: messenger/external_control_bot_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FileDescriptorProto as FileDescriptorProto1 } from "ts-proto-descriptors";
import { Empty, protoMetadata as protoMetadata1 } from "../google/protobuf/empty";

export const protobufPackage = "externalcontrolbot";

/**
 * ControlType selects how an external client takes over: directly via the SDK
 * (API) or through the ROS bridge for a given distro.
 * TODO(external-control): ROS_JAZZY is plumbed end-to-end but intentionally NOT
 * exposed in the step wizard / settings UI yet — expose it once the jazzy bridge
 * env is validated for customers.
 */
export enum ControlType {
  CONTROL_TYPE_UNSPECIFIED = 0,
  CONTROL_TYPE_API = 1,
  CONTROL_TYPE_ROS_HUMBLE = 2,
  CONTROL_TYPE_ROS_JAZZY = 3,
  UNRECOGNIZED = -1,
}

export function controlTypeFromJSON(object: any): ControlType {
  switch (object) {
    case 0:
    case "CONTROL_TYPE_UNSPECIFIED":
      return ControlType.CONTROL_TYPE_UNSPECIFIED;
    case 1:
    case "CONTROL_TYPE_API":
      return ControlType.CONTROL_TYPE_API;
    case 2:
    case "CONTROL_TYPE_ROS_HUMBLE":
      return ControlType.CONTROL_TYPE_ROS_HUMBLE;
    case 3:
    case "CONTROL_TYPE_ROS_JAZZY":
      return ControlType.CONTROL_TYPE_ROS_JAZZY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ControlType.UNRECOGNIZED;
  }
}

export function controlTypeToJSON(object: ControlType): string {
  switch (object) {
    case ControlType.CONTROL_TYPE_UNSPECIFIED:
      return "CONTROL_TYPE_UNSPECIFIED";
    case ControlType.CONTROL_TYPE_API:
      return "CONTROL_TYPE_API";
    case ControlType.CONTROL_TYPE_ROS_HUMBLE:
      return "CONTROL_TYPE_ROS_HUMBLE";
    case ControlType.CONTROL_TYPE_ROS_JAZZY:
      return "CONTROL_TYPE_ROS_JAZZY";
    case ControlType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * StreamType is informational at this layer: external-control-bot only logs it.
 * The control-source lease is set by the External Control Step on arm-control-bot.
 */
export enum StreamType {
  STREAM_TYPE_UNSPECIFIED = 0,
  STREAM_TYPE_POSE = 1,
  STREAM_TYPE_JOINTS = 2,
  STREAM_TYPE_TRAJECTORY = 3,
  UNRECOGNIZED = -1,
}

export function streamTypeFromJSON(object: any): StreamType {
  switch (object) {
    case 0:
    case "STREAM_TYPE_UNSPECIFIED":
      return StreamType.STREAM_TYPE_UNSPECIFIED;
    case 1:
    case "STREAM_TYPE_POSE":
      return StreamType.STREAM_TYPE_POSE;
    case 2:
    case "STREAM_TYPE_JOINTS":
      return StreamType.STREAM_TYPE_JOINTS;
    case 3:
    case "STREAM_TYPE_TRAJECTORY":
      return StreamType.STREAM_TYPE_TRAJECTORY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StreamType.UNRECOGNIZED;
  }
}

export function streamTypeToJSON(object: StreamType): string {
  switch (object) {
    case StreamType.STREAM_TYPE_UNSPECIFIED:
      return "STREAM_TYPE_UNSPECIFIED";
    case StreamType.STREAM_TYPE_POSE:
      return "STREAM_TYPE_POSE";
    case StreamType.STREAM_TYPE_JOINTS:
      return "STREAM_TYPE_JOINTS";
    case StreamType.STREAM_TYPE_TRAJECTORY:
      return "STREAM_TYPE_TRAJECTORY";
    case StreamType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ControllerType {
  CONTROLLER_TYPE_UNKNOWN = 0,
  CONTROLLER_TYPE_UDP = 1,
  CONTROLLER_TYPE_ROS = 2,
  UNRECOGNIZED = -1,
}

export function controllerTypeFromJSON(object: any): ControllerType {
  switch (object) {
    case 0:
    case "CONTROLLER_TYPE_UNKNOWN":
      return ControllerType.CONTROLLER_TYPE_UNKNOWN;
    case 1:
    case "CONTROLLER_TYPE_UDP":
      return ControllerType.CONTROLLER_TYPE_UDP;
    case 2:
    case "CONTROLLER_TYPE_ROS":
      return ControllerType.CONTROLLER_TYPE_ROS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ControllerType.UNRECOGNIZED;
  }
}

export function controllerTypeToJSON(object: ControllerType): string {
  switch (object) {
    case ControllerType.CONTROLLER_TYPE_UNKNOWN:
      return "CONTROLLER_TYPE_UNKNOWN";
    case ControllerType.CONTROLLER_TYPE_UDP:
      return "CONTROLLER_TYPE_UDP";
    case ControllerType.CONTROLLER_TYPE_ROS:
      return "CONTROLLER_TYPE_ROS";
    case ControllerType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface StartExternalStreamRequest {
  controlType: ControlType;
  streamType: StreamType;
}

export interface ExternalControllerStateMsg {
  hasActiveController: boolean;
  controllerType: ControllerType;
}

function createBaseStartExternalStreamRequest(): StartExternalStreamRequest {
  return { controlType: 0, streamType: 0 };
}

export const StartExternalStreamRequest: MessageFns<StartExternalStreamRequest> = {
  encode(message: StartExternalStreamRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.controlType !== 0) {
      writer.uint32(8).int32(message.controlType);
    }
    if (message.streamType !== 0) {
      writer.uint32(16).int32(message.streamType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartExternalStreamRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartExternalStreamRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.controlType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.streamType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartExternalStreamRequest {
    return {
      controlType: isSet(object.controlType) ? controlTypeFromJSON(object.controlType) : 0,
      streamType: isSet(object.streamType) ? streamTypeFromJSON(object.streamType) : 0,
    };
  },

  toJSON(message: StartExternalStreamRequest): unknown {
    const obj: any = {};
    if (message.controlType !== 0) {
      obj.controlType = controlTypeToJSON(message.controlType);
    }
    if (message.streamType !== 0) {
      obj.streamType = streamTypeToJSON(message.streamType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StartExternalStreamRequest>, I>>(base?: I): StartExternalStreamRequest {
    return StartExternalStreamRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartExternalStreamRequest>, I>>(object: I): StartExternalStreamRequest {
    const message = createBaseStartExternalStreamRequest();
    message.controlType = object.controlType ?? 0;
    message.streamType = object.streamType ?? 0;
    return message;
  },
};

function createBaseExternalControllerStateMsg(): ExternalControllerStateMsg {
  return { hasActiveController: false, controllerType: 0 };
}

export const ExternalControllerStateMsg: MessageFns<ExternalControllerStateMsg> = {
  encode(message: ExternalControllerStateMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hasActiveController !== false) {
      writer.uint32(8).bool(message.hasActiveController);
    }
    if (message.controllerType !== 0) {
      writer.uint32(16).int32(message.controllerType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExternalControllerStateMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExternalControllerStateMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.hasActiveController = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.controllerType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExternalControllerStateMsg {
    return {
      hasActiveController: isSet(object.hasActiveController) ? globalThis.Boolean(object.hasActiveController) : false,
      controllerType: isSet(object.controllerType) ? controllerTypeFromJSON(object.controllerType) : 0,
    };
  },

  toJSON(message: ExternalControllerStateMsg): unknown {
    const obj: any = {};
    if (message.hasActiveController !== false) {
      obj.hasActiveController = message.hasActiveController;
    }
    if (message.controllerType !== 0) {
      obj.controllerType = controllerTypeToJSON(message.controllerType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExternalControllerStateMsg>, I>>(base?: I): ExternalControllerStateMsg {
    return ExternalControllerStateMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExternalControllerStateMsg>, I>>(object: I): ExternalControllerStateMsg {
    const message = createBaseExternalControllerStateMsg();
    message.hasActiveController = object.hasActiveController ?? false;
    message.controllerType = object.controllerType ?? 0;
    return message;
  },
};

/** @language: cpp */
export interface ExternalControlBotTopics {
  ExternalControllerState(request: ExternalControllerStateMsg): Promise<Empty>;
}

export const ExternalControlBotTopicsServiceName = "externalcontrolbot.ExternalControlBotTopics";
export class ExternalControlBotTopicsClientImpl implements ExternalControlBotTopics {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || ExternalControlBotTopicsServiceName;
    this.rpc = rpc;
    this.ExternalControllerState = this.ExternalControllerState.bind(this);
  }
  ExternalControllerState(request: ExternalControllerStateMsg): Promise<Empty> {
    const data = ExternalControllerStateMsg.encode(request).finish();
    const promise = this.rpc.request(this.service, "ExternalControllerState", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }
}

/** @language: cpp */
export interface ExternalControlBotService {
  /**
   * Begin an external-control session. CONTROL_TYPE_API is a no-op (the client
   * speaks the SDK/UDP protocol directly); ROS_HUMBLE/ROS_JAZZY start the bridge
   * with that distro. Idempotent: same distro is a no-op, a different one
   * restarts the bridge.
   */
  StartExternalStream(request: StartExternalStreamRequest): Promise<Empty>;
  /** End the session: stop the bridge if one is running (no-op otherwise). */
  EndExternalStream(request: Empty): Promise<Empty>;
}

export const ExternalControlBotServiceServiceName = "externalcontrolbot.ExternalControlBotService";
export class ExternalControlBotServiceClientImpl implements ExternalControlBotService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || ExternalControlBotServiceServiceName;
    this.rpc = rpc;
    this.StartExternalStream = this.StartExternalStream.bind(this);
    this.EndExternalStream = this.EndExternalStream.bind(this);
  }
  StartExternalStream(request: StartExternalStreamRequest): Promise<Empty> {
    const data = StartExternalStreamRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "StartExternalStream", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  EndExternalStream(request: Empty): Promise<Empty> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "EndExternalStream", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type ProtoMetaMessageOptions = {
  options?: { [key: string]: any };
  fields?: { [key: string]: { [key: string]: any } };
  oneof?: { [key: string]: { [key: string]: any } };
  nested?: { [key: string]: ProtoMetaMessageOptions };
};

export interface ProtoMetadata {
  fileDescriptor: FileDescriptorProto1;
  references: { [key: string]: any };
  dependencies?: ProtoMetadata[];
  options?: {
    options?: { [key: string]: any };
    services?: {
      [key: string]: { options?: { [key: string]: any }; methods?: { [key: string]: { [key: string]: any } } };
    };
    messages?: { [key: string]: ProtoMetaMessageOptions };
    enums?: { [key: string]: { options?: { [key: string]: any }; values?: { [key: string]: { [key: string]: any } } } };
  };
}

export const protoMetadata: ProtoMetadata = {
  fileDescriptor: {
    "name": "messenger/external_control_bot_service.proto",
    "package": "externalcontrolbot",
    "dependency": ["google/protobuf/empty.proto"],
    "publicDependency": [],
    "weakDependency": [],
    "messageType": [{
      "name": "StartExternalStreamRequest",
      "field": [{
        "name": "control_type",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".externalcontrolbot.ControlType",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "controlType",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "stream_type",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".externalcontrolbot.StreamType",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "streamType",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ExternalControllerStateMsg",
      "field": [{
        "name": "has_active_controller",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "hasActiveController",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "controller_type",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".externalcontrolbot.ControllerType",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "controllerType",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "enumType": [{
      "name": "ControlType",
      "value": [
        { "name": "CONTROL_TYPE_UNSPECIFIED", "number": 0, "options": undefined },
        { "name": "CONTROL_TYPE_API", "number": 1, "options": undefined },
        { "name": "CONTROL_TYPE_ROS_HUMBLE", "number": 2, "options": undefined },
        { "name": "CONTROL_TYPE_ROS_JAZZY", "number": 3, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "StreamType",
      "value": [
        { "name": "STREAM_TYPE_UNSPECIFIED", "number": 0, "options": undefined },
        { "name": "STREAM_TYPE_POSE", "number": 1, "options": undefined },
        { "name": "STREAM_TYPE_JOINTS", "number": 2, "options": undefined },
        { "name": "STREAM_TYPE_TRAJECTORY", "number": 3, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ControllerType",
      "value": [{ "name": "CONTROLLER_TYPE_UNKNOWN", "number": 0, "options": undefined }, {
        "name": "CONTROLLER_TYPE_UDP",
        "number": 1,
        "options": undefined,
      }, { "name": "CONTROLLER_TYPE_ROS", "number": 2, "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "service": [{
      "name": "ExternalControlBotTopics",
      "method": [{
        "name": "ExternalControllerState",
        "inputType": ".externalcontrolbot.ExternalControllerStateMsg",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }, {
      "name": "ExternalControlBotService",
      "method": [{
        "name": "StartExternalStream",
        "inputType": ".externalcontrolbot.StartExternalStreamRequest",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "EndExternalStream",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }],
    "extension": [],
    "options": {
      "javaPackage": "",
      "javaOuterClassname": "",
      "javaMultipleFiles": false,
      "javaGenerateEqualsAndHash": false,
      "javaStringCheckUtf8": false,
      "optimizeFor": 1,
      "goPackage": "sb.app/messenger/proto/externalcontrolbot",
      "ccGenericServices": false,
      "javaGenericServices": false,
      "pyGenericServices": false,
      "phpGenericServices": false,
      "deprecated": false,
      "ccEnableArenas": true,
      "objcClassPrefix": "",
      "csharpNamespace": "",
      "swiftPrefix": "",
      "phpClassPrefix": "",
      "phpNamespace": "",
      "phpMetadataNamespace": "",
      "rubyPackage": "",
      "uninterpretedOption": [],
    },
    "sourceCodeInfo": {
      "location": [{
        "path": [6, 0],
        "span": [7, 0, 9, 1],
        "leadingComments": " @language: cpp\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 0],
        "span": [16, 0, 21, 1],
        "leadingComments":
          " ControlType selects how an external client takes over: directly via the SDK\n (API) or through the ROS bridge for a given distro.\n TODO(external-control): ROS_JAZZY is plumbed end-to-end but intentionally NOT\n exposed in the step wizard / settings UI yet — expose it once the jazzy bridge\n env is validated for customers.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1],
        "span": [25, 0, 30, 1],
        "leadingComments":
          " StreamType is informational at this layer: external-control-bot only logs it.\n The control-source lease is set by the External Control Step on arm-control-bot.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 1],
        "span": [38, 0, 46, 1],
        "leadingComments": " @language: cpp\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 1, 2, 0],
        "span": [43, 2, 86],
        "leadingComments":
          " Begin an external-control session. CONTROL_TYPE_API is a no-op (the client\n speaks the SDK/UDP protocol directly); ROS_HUMBLE/ROS_JAZZY start the bridge\n with that distro. Idempotent: same distro is a no-op, a different one\n restarts the bridge.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 1, 2, 1],
        "span": [45, 2, 79],
        "leadingComments": " End the session: stop the bridge if one is running (no-op otherwise).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }],
    },
    "syntax": "proto3",
  },
  references: {
    ".externalcontrolbot.ControlType": ControlType,
    ".externalcontrolbot.StreamType": StreamType,
    ".externalcontrolbot.ControllerType": ControllerType,
    ".externalcontrolbot.StartExternalStreamRequest": StartExternalStreamRequest,
    ".externalcontrolbot.ExternalControllerStateMsg": ExternalControllerStateMsg,
    ".externalcontrolbot.ExternalControlBotTopics": ExternalControlBotTopicsClientImpl,
    ".externalcontrolbot.ExternalControlBotService": ExternalControlBotServiceClientImpl,
  },
  dependencies: [protoMetadata1],
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
